import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ac42f1e8")

_pushScopeId("data-v-ac42f1e8")
const _hoisted_1 = { class: "editor-header" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { class: "menu-item" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode()
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "text" }, "编辑", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("撤销")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("重做")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("添加页面")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("删除页面")
const _hoisted_10 = { class: "menu-item" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode()
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "text" }, "演示", -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("从头开始")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("从当前页开始")
const _hoisted_15 = { class: "menu-item" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode()
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { class: "text" }, "帮助", -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode("快捷键")
const _hoisted_19 = {
  key: 0,
  class: "center"
}
const _hoisted_20 = /*#__PURE__*/_createTextVNode("课程名: ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("教材版本: ")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("当前授课课时: ")
const _hoisted_23 = {
  key: 1,
  class: "center"
}
const _hoisted_24 = /*#__PURE__*/_createTextVNode("课件名称: ")
const _hoisted_25 = { key: 0 }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("课程名称: ")
const _hoisted_27 = { class: "right" }
const _hoisted_28 = {
  key: 0,
  style: {"margin-right":"10px"}
}
const _hoisted_29 = {
  key: 0,
  class: "hour"
}
const _hoisted_30 = { key: 1 }
const _hoisted_31 = /*#__PURE__*/_createVNode("span", null, "课件名称", -1)
const _hoisted_32 = /*#__PURE__*/_createVNode("span", null, "课程名称", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_IconEdit = _resolveComponent("IconEdit")
  const _component_MenuItem = _resolveComponent("MenuItem")
  const _component_Menu = _resolveComponent("Menu")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_IconPpt = _resolveComponent("IconPpt")
  const _component_IconHelpcenter = _resolveComponent("IconHelpcenter")
  const _component_Tooltip = _resolveComponent("Tooltip")
  const _component_Input = _resolveComponent("Input")
  const _component_Modal = _resolveComponent("Modal")
  const _component_HotkeyDoc = _resolveComponent("HotkeyDoc")
  const _component_Drawer = _resolveComponent("Drawer")
  const _component_ResourcePool = _resolveComponent("ResourcePool")
  const _component_ExportDialog = _resolveComponent("ExportDialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Dropdown, { trigger: ['click'] }, {
        overlay: _withId(() => [
          _createVNode(_component_Menu, null, {
            default: _withId(() => [
              _createVNode(_component_MenuItem, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.undo()))
              }, {
                default: _withId(() => [
                  _hoisted_6
                ]),
                _: 1
              }),
              _createVNode(_component_MenuItem, {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.redo()))
              }, {
                default: _withId(() => [
                  _hoisted_7
                ]),
                _: 1
              }),
              _createVNode(_component_MenuItem, {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.createSlide()))
              }, {
                default: _withId(() => [
                  _hoisted_8
                ]),
                _: 1
              }),
              _createVNode(_component_MenuItem, {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.deleteSlide()))
              }, {
                default: _withId(() => [
                  _hoisted_9
                ]),
                _: 1
              }),
              _createVNode(_component_MenuItem, {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toggleGridLines()))
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.showGridLines ? '关闭网格线' : '打开网格线'), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withId(() => [
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_IconEdit),
            _hoisted_4,
            _hoisted_5
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_Dropdown, { trigger: ['click'] }, {
        overlay: _withId(() => [
          _createVNode(_component_Menu, null, {
            default: _withId(() => [
              _createVNode(_component_MenuItem, {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.enterScreeningFromStart()))
              }, {
                default: _withId(() => [
                  _hoisted_13
                ]),
                _: 1
              }),
              _createVNode(_component_MenuItem, {
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.enterScreening()))
              }, {
                default: _withId(() => [
                  _hoisted_14
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withId(() => [
          _createVNode("div", _hoisted_10, [
            _createVNode(_component_IconPpt),
            _hoisted_11,
            _hoisted_12
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_Dropdown, { trigger: ['click'] }, {
        overlay: _withId(() => [
          _createVNode(_component_Menu, null, {
            default: _withId(() => [
              _createVNode(_component_MenuItem, {
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.hotkeyDrawerVisible = true))
              }, {
                default: _withId(() => [
                  _hoisted_18
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withId(() => [
          _createVNode("div", _hoisted_15, [
            _createVNode(_component_IconHelpcenter),
            _hoisted_16,
            _hoisted_17
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_Tooltip, {
        mouseLeaveDelay: 0,
        title: "从资源库导入"
      }, {
        default: _withId(() => [
          _createVNode("div", {
            class: "menu-item",
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.openZiYuan && _ctx.openZiYuan(...args)))
          }, " 资源库 ")
        ]),
        _: 1
      })
    ]),
    (_ctx.hourId)
      ? (_openBlock(), _createBlock("div", _hoisted_19, [
          _createVNode("p", null, [
            _hoisted_20,
            _createVNode("span", null, _toDisplayString(_ctx.teachCourseName), 1)
          ]),
          _createVNode("p", null, [
            _hoisted_21,
            _createVNode("span", null, _toDisplayString(_ctx.teachTextbookVersion), 1)
          ]),
          _createVNode("p", null, [
            _hoisted_22,
            _createVNode("span", null, _toDisplayString(_ctx.teachCurrentClass), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.editPPtId&&!_ctx.hourId)
      ? (_openBlock(), _createBlock("div", _hoisted_23, [
          _createVNode("p", null, [
            _hoisted_24,
            _createVNode("span", null, _toDisplayString(_ctx.name), 1)
          ]),
          (_ctx.courseName)
            ? (_openBlock(), _createBlock("p", _hoisted_25, [
                _hoisted_26,
                _createVNode("span", null, _toDisplayString(_ctx.courseName), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_27, [
      _createVNode(_component_Menu, null, {
        default: _withId(() => [
          (_ctx.editPPtId&&!_ctx.hourId)
            ? (_openBlock(), _createBlock("li", _hoisted_28, _toDisplayString('上次保存时间: ' + _ctx.lastSavedTime), 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_Tooltip, {
        mouseLeaveDelay: 0,
        title: "幻灯片放映"
      }, {
        default: _withId(() => [
          _createVNode("div", {
            class: "menu-item",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.enterScreening()))
          }, [
            _createVNode(_component_IconPpt, {
              size: "18",
              fill: "#666",
              style: {"margin-top":"2px"}
            })
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_Tooltip, { mouseLeaveDelay: 0 }, {
        default: _withId(() => [
          _createVNode("div", {
            class: "menu-item",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.openModal = true))
          }, _toDisplayString(_ctx.hourId ? '完成授课' : '保存课件'), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_Modal, {
        visible: _ctx.openModal,
        title: _ctx.hourId ? '提示' : '保存' ,
        okText: "确认",
        cancelText: "取消",
        centered: true,
        onOk: _ctx.saveData,
        onCancel: _cache[14] || (_cache[14] = ($event: any) => (_ctx.openModal = false))
      }, {
        default: _withId(() => [
          (_ctx.hourId)
            ? (_openBlock(), _createBlock("div", _hoisted_29, " 是否确定完成授课 "))
            : (_openBlock(), _createBlock("div", _hoisted_30, [
                _createVNode("div", null, [
                  _hoisted_31,
                  _createVNode(_component_Input, {
                    value: _ctx.name,
                    "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => (_ctx.name = $event))
                  }, null, 8, ["value"])
                ]),
                _createVNode("div", null, [
                  _hoisted_32,
                  _createVNode(_component_Input, {
                    value: _ctx.courseName,
                    "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => (_ctx.courseName = $event)),
                    disabled: true
                  }, null, 8, ["value"])
                ])
              ]))
        ]),
        _: 1
      }, 8, ["visible", "title", "onOk"]),
      _createVNode(_component_Modal, {
        visible: _ctx.poll,
        title: "资源库",
        class: "border",
        width: "100%",
        centered: true,
        onOk: _ctx.saveData,
        onCancel: _cache[15] || (_cache[15] = ($event: any) => (_ctx.poll = !_ctx.poll))
      }, {
        default: _withId(() => [
          _createVNode("iframe", {
            id: "iframe",
            ref: "iframe",
            width: "100%",
            height: "100%",
            frameborder: "0",
            scrolling: "auto",
            src: _ctx.ipSrc + '/#/workbench/resourcePool?test=true&editPPtId=' + _ctx.editPPtId,
            webkitallowfullscreen: true,
            mozallowfullscreen: true,
            allowfullscreen: true
          }, "\r\n        ", 8, ["src"])
        ]),
        _: 1
      }, 8, ["visible", "onOk"])
    ]),
    _createVNode(_component_Drawer, {
      width: "320",
      placement: "right",
      visible: _ctx.hotkeyDrawerVisible,
      onClose: _cache[16] || (_cache[16] = ($event: any) => (_ctx.hotkeyDrawerVisible = false))
    }, {
      default: _withId(() => [
        _createVNode(_component_HotkeyDoc)
      ]),
      _: 1
    }, 8, ["visible"]),
    (_ctx.resources)
      ? (_openBlock(), _createBlock(_component_Drawer, {
          key: 2,
          width: "380",
          placement: "right",
          visible: _ctx.resources,
          mask: false,
          onClose: _cache[17] || (_cache[17] = ($event: any) => (_ctx.resources = !_ctx.resources))
        }, {
          default: _withId(() => [
            _createVNode(_component_ResourcePool)
          ]),
          _: 1
        }, 8, ["visible"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Modal, {
      visible: _ctx.exportDialogVisible,
      "onUpdate:visible": _cache[19] || (_cache[19] = ($event: any) => (_ctx.exportDialogVisible = $event)),
      footer: null,
      centered: "",
      closable: false,
      width: 680,
      destroyOnClose: ""
    }, {
      default: _withId(() => [
        _createVNode(_component_ExportDialog, {
          onClose: _cache[18] || (_cache[18] = ($event: any) => (_ctx.exportDialogVisible = false))
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
})